// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"59":"ac93b218","93":"d21edad4","144":"693c01a1","178":"b0d93db0","277":"66133c50","426":"9093f836","653":"2fd1d8b1","681":"14f33598","682":"d3f40c8c","724":"02d8cf50","795":"9829d0d7","866":"887b0a6e","969":"e647019d"}[chunkId] + ".chunk.js";
};